




















































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { LocaleMixin } from '@/locales/locale-mixin';
import { StatusesStore } from '@/families/store/statuses-store';
import { LoadingStore } from '@/store/loading-store';
import { BaseStatuses } from '@/constants/status-constants';
import { Status } from '@/families/models/status';
import { EventTypes } from '@/constants/event-type-constants';
import { IntegrationRepository } from '../repositories/integration-repository';
import { StatusControlsMapper, StatusControlsViewModel } from '../mappers/status-controls-mapper';
import { getStatusesBetweenWaitListAndLostOpp } from '@/families/status-utils';
import store from '@/store';

const statusesState = getModule(StatusesStore, store);
const loadingState = getModule(LoadingStore);

@Component
export default class StatusControls extends Mixins(LocaleMixin) {
    @Prop({ default: false }) isOpen!: boolean;
    @Prop({ default: 0 }) integrationPartnerId!: number;

    private viewModel: StatusControlsViewModel = {
        exportChildrenInWaitList: false,
        futureStartDateStatus: BaseStatuses.REGISTERED,
        activeBookingStatus: BaseStatuses.ENROLLED,
        endedBookingStatus: BaseStatuses.WITHDRAWN
    };

    private integrationRepository = new IntegrationRepository();
    private isSaving = false;
    private loadingKey = 'statusControls';
    private statusControlsMapper = new StatusControlsMapper();
    private validForm = true;

    private get availableStatuses(): Array<Status> {
        return getStatusesBetweenWaitListAndLostOpp(statusesState.statuses);
    }

    @Watch('isOpen', { immediate: true })
    private async onModalOpen(): Promise<void> {
        if (this.isOpen) {
            await statusesState.init();
            await this.loadExistingSettings();
        }
    }

    private closeModal(): void {
        this.$emit(EventTypes.CLOSE);
    }

    private getStatusName(statusId: number): string {
        const status = statusesState.statuses.find(s => s.id === statusId);
        return status ? status.name : '';
    }

    private async loadExistingSettings(): Promise<void> {
        if (!this.integrationPartnerId) {
            return;
        }

        loadingState.loadingIncrement(this.loadingKey);

        try {
            const settings = await this.integrationRepository.getStatusControls(this.integrationPartnerId);
            this.viewModel = this.statusControlsMapper.toViewModel(settings);
        } catch (error) {
            this.viewModel = this.statusControlsMapper.toDefaultViewModel();
        } finally {
            loadingState.loadingDecrement(this.loadingKey);
        }
    }

    private async saveSettings(): Promise<void> {
        if (!this.validForm || !this.integrationPartnerId) {
            return;
        }

        this.isSaving = true;
        loadingState.loadingIncrement(this.loadingKey);

        try {
            const payload = this.statusControlsMapper.toDto(this.viewModel);
            await this.integrationRepository.saveStatusControls(this.integrationPartnerId, payload);

            this.$emit(EventTypes.UPDATED);
            this.closeModal();
        } catch (error) {
            this.$emit(EventTypes.SETTINGS_CHANGED, { success: false });
        } finally {
            this.isSaving = false;
            loadingState.loadingDecrement(this.loadingKey);
        }
    }
}
